import { connect } from 'react-redux'
import Results from './Results'
import { listenForPoll, removePoll } from '../../redux/actions/poll'
import { listenForResults } from '../../redux/actions/results'

const mapStateToProps = ({ polls, results, user }, { params }) => ({
	enableRemove: user && polls[params.pollId] && user.uid === polls[params.pollId].uid,
	poll: polls[params.pollId],
	results: results[params.pollId],
})

const mapDispatchToProps = (dispatch, { params }) => ({
	load() {
		const { pollId } = params
		dispatch(listenForPoll(pollId))
		dispatch(listenForResults(pollId))
	},
	remove() {
		const { pollId } = params
		dispatch(removePoll(pollId))
	},
})

const Container = connect(
	mapStateToProps,
	mapDispatchToProps,
)(Results)

export default Container



// WEBPACK FOOTER //
// ./src/components/results/Container.jsx